<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
  <div class="container-header-inner">
    <div class="page-head page-head--with-action">
      <div class="page-head-text">
        <h1 class="title-default">Comunicação de Cotação</h1>
        <p class="welcome-message">
          <button mat-icon-button type="button" (click)="voltar()">
            <mat-icon>arrow_back</mat-icon>
          </button>
          Configure a identidade visual, os campos do formulário e o e-mail enviado ao fornecedor.
        </p>
      </div>
      <div class="page-head-actions">
        <button mat-stroked-button type="button" class="btn-secondary" [disabled]="isLoading" (click)="abrirPreview()">
          <mat-icon class="material-symbols-outlined">visibility</mat-icon>
          Visualizar
        </button>
      </div>
    </div>

    @if (isLoading) {
    <div class="config-layout">
      <app-loading-box height="180" margin="0 0 24px 0"></app-loading-box>
      <app-loading-box height="180" margin="0 0 24px 0"></app-loading-box>
      <app-loading-box height="180" margin="0 0 24px 0"></app-loading-box>
    </div>
    } @else {
    <form [formGroup]="form">
      <div class="row config-layout">
        <div class="col-12">
          <section class="section-container">
            <div class="section-title">
              <mat-icon class="material-symbols-outlined">palette</mat-icon>
              <span>Identidade visual</span>
            </div>

            <div class="row">
              <div class="col-12 col-md-4 mb-3">
                <label class="field-label">Logo</label>
                <div class="logo-box">
                  @if (logoDataUrl) {
                    <img [src]="logoDataUrl" alt="Logo da empresa">
                    <button mat-icon-button type="button" class="remove-logo" (click)="removeLogo()" matTooltip="Remover logo">
                      <mat-icon>close</mat-icon>
                    </button>
                  } @else {
                    <span class="logo-fallback" [style.background]="form.get('brandColor')?.value">
                      {{ form.get('brandShort')?.value || 'ATS' }}
                    </span>
                  }
                </div>
                <input #logoInput type="file" accept="image/png,image/jpeg,image/svg+xml" hidden (change)="onLogoSelected($event)">
                <button mat-stroked-button type="button" class="w-100" (click)="logoInput.click()">
                  <mat-icon class="material-symbols-outlined">upload</mat-icon>
                  {{ logoDataUrl ? 'Trocar logo' : 'Enviar logo' }}
                </button>
                <div class="hint-text text-center mt-2">PNG, JPG ou SVG até 500 KB</div>
              </div>

              <div class="col-12 col-md-8">
                <!-- Espaçador com a altura do label "Logo" para os campos alinharem com o topo do box do logo. -->
                <label class="field-label logo-align-spacer" aria-hidden="true">&nbsp;</label>
                <div class="row">
                  <div class="col-12 col-md-5">
                    <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-100">
                      <mat-label>Nome curto</mat-label>
                      <input matInput formControlName="brandShort" maxlength="4" placeholder="ATS">
                    </mat-form-field>
                  </div>
                  <div class="col-12 col-md-7">
                    <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-100">
                      <mat-label>Texto do rodapé do logo</mat-label>
                      <input matInput formControlName="brandTagline" placeholder="Portal do Fornecedor">
                    </mat-form-field>
                  </div>
                  <div class="col-12 col-md-4">
                    <div class="color-field-row">
                      <input type="color" formControlName="brandColor" class="color-swatch"
                        (input)="onColorChange($event, 'brandColor')">
                      <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-100">
                        <mat-label>Cor da marca</mat-label>
                        <input matInput type="text" formControlName="brandColor"
                          placeholder="#B73232" maxlength="7" (input)="onColorChange($event, 'brandColor')">
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="col-6 col-md-4">
                    <div class="color-field-row">
                      <input type="color" formControlName="heroBg" class="color-swatch"
                        (input)="onColorChange($event, 'heroBg')">
                      <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-100">
                        <mat-label>Hero início</mat-label>
                        <input matInput type="text" formControlName="heroBg"
                          placeholder="#1C1B1F" maxlength="7" (input)="onColorChange($event, 'heroBg')">
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="col-6 col-md-4">
                    <div class="color-field-row">
                      <input type="color" formControlName="heroBgEnd" class="color-swatch"
                        (input)="onColorChange($event, 'heroBgEnd')">
                      <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-100">
                        <mat-label>Hero fim</mat-label>
                        <input matInput type="text" formControlName="heroBgEnd"
                          placeholder="#2D2A3A" maxlength="7" (input)="onColorChange($event, 'heroBgEnd')">
                      </mat-form-field>
                    </div>
                  </div>
                </div>

                <div class="preset-list">
                  @for (preset of presetColors; track preset.color) {
                    <button type="button" class="preset-chip"
                      [class.active]="preset.color.toLowerCase() === form.get('brandColor')?.value?.toLowerCase()"
                      (click)="applyPreset(preset)">
                      <i [style.background]="preset.color"></i>
                      {{ preset.name }}
                    </button>
                  }
                </div>
              </div>
            </div>
          </section>

          <section class="section-container">
            <div class="section-title">
              <mat-icon class="material-symbols-outlined">business</mat-icon>
              <span>Dados da empresa</span>
            </div>

            <div class="row">
              <div class="col-12 col-md-8">
                <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-100">
                  <mat-label>Razão social</mat-label>
                  <input matInput formControlName="brandName">
                </mat-form-field>
              </div>
              <div class="col-12 col-md-4">
                <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-100">
                  <mat-label>CNPJ</mat-label>
                  <input matInput formControlName="buyerCnpj">
                </mat-form-field>
              </div>
              <div class="col-12">
                <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-100">
                  <mat-label>Endereço</mat-label>
                  <input matInput formControlName="buyerAddress">
                </mat-form-field>
              </div>
              <div class="col-12 col-md-6">
                <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-100">
                  <mat-label>E-mail de compras</mat-label>
                  <input matInput formControlName="buyerEmail">
                </mat-form-field>
              </div>
              <div class="col-12 col-md-6">
                <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-100">
                  <mat-label>Telefone</mat-label>
                  <input matInput formControlName="buyerPhone">
                </mat-form-field>
              </div>
            </div>
          </section>

          <section class="section-container">
            <div class="section-title">
              <mat-icon class="material-symbols-outlined">language</mat-icon>
              <span>Portal do fornecedor</span>
            </div>

            <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-100">
              <mat-label>Subdomínio do portal</mat-label>
              <input matInput formControlName="portalSubdomain">
            </mat-form-field>

            <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-100">
              <mat-label>Mensagem de boas-vindas</mat-label>
              <textarea matInput formControlName="welcomeMessage" rows="3"></textarea>
            </mat-form-field>
          </section>

          <section class="section-container">
            <div class="section-title">
              <mat-icon class="material-symbols-outlined">send</mat-icon>
              <span>Formato de envio</span>
            </div>

            <div class="format-grid">
              @for (format of formatOptions; track format.key) {
                <article
                  class="format-card"
                  role="checkbox"
                  tabindex="0"
                  [attr.aria-checked]="isFormatSelected(format.key)"
                  [class.format-card--selected]="isFormatSelected(format.key)"
                  (click)="toggleFormat(format.key)"
                  (keydown.enter)="toggleFormat(format.key)"
                  (keydown.space)="toggleFormat(format.key); $event.preventDefault()">
                  <div class="format-card-header">
                    <mat-icon class="format-checkbox-icon">
                      {{ isFormatSelected(format.key) ? 'check_box' : 'check_box_outline_blank' }}
                    </mat-icon>
                    <h2>{{ format.label }}</h2>
                    <mat-icon class="format-option-icon">{{ format.icon }}</mat-icon>
                  </div>
                  <div class="format-card-divider"></div>
                  <p>{{ format.hint }}</p>
                </article>
              }
            </div>
          </section>

          <section class="section-container">
            <div class="section-title">
              <mat-icon class="material-symbols-outlined">dynamic_form</mat-icon>
              <span>Campos do formulário</span>
            </div>

            <div class="fields-layout">
              <div class="fields-column">
                <div class="fields-column-title">
                  <mat-icon class="material-symbols-outlined">cloud_sync</mat-icon>
                  <span>Enviados automaticamente</span>
                </div>
                <p class="fields-column-hint">Estes dados vão no formulário em modo de leitura e o fornecedor não pode editar.</p>

                <div class="field-list">
                  @for (field of autoFields; track field.name) {
                    <div class="field-row field-row--icon-action field-row--auto">
                      <span class="field-row-icon">
                        <mat-icon class="material-symbols-outlined">{{ field.icon }}</mat-icon>
                      </span>
                      <div>
                        <strong>{{ field.name }}</strong>
                        <p>{{ field.meta }}</p>
                      </div>
                      <span class="field-action">
                        <mat-icon class="material-symbols-outlined">cloud_done</mat-icon>
                      </span>
                    </div>
                  }
                </div>
              </div>

              <div class="fields-column">
                <div class="fields-column-title">
                  <mat-icon class="material-symbols-outlined">format_list_bulleted</mat-icon>
                  <span>O fornecedor preenche</span>
                </div>
                <p class="fields-column-hint">Ative ou desative os campos opcionais. Os obrigatórios são sempre solicitados.</p>

                <div class="field-list">
                  @for (field of requiredFields; track field.key) {
                    <div class="field-row field-row--icon-action">
                      <span class="field-row-icon">
                        <mat-icon class="material-symbols-outlined">{{ field.icon }}</mat-icon>
                      </span>
                      <div>
                        <strong>{{ field.name }}</strong>
                        <p>{{ field.type }}{{ field.hint ? ' · ' + field.hint : '' }}</p>
                      </div>
                      <span class="field-action">
                        <mat-icon class="material-symbols-outlined">lock</mat-icon>
                      </span>
                    </div>
                  }

                  @for (field of optionalFields; track field.key) {
                    <div class="field-row" [class.field-row-muted]="!isFieldActive(field)">
                      <span class="field-row-icon">
                        <mat-icon class="material-symbols-outlined">{{ field.icon }}</mat-icon>
                      </span>
                      <div>
                        <strong>{{ field.name }}</strong>
                        <p>{{ field.type }}{{ field.hint ? ' · ' + field.hint : '' }}</p>
                      </div>
                      <mat-slide-toggle class="app-toggle-compact field-toggle" color="primary" [formControlName]="field.key"></mat-slide-toggle>
                    </div>
                  }
                </div>
              </div>
            </div>
          </section>

          <section class="section-container">
            <div class="section-title">
              <mat-icon class="material-symbols-outlined">alternate_email</mat-icon>
              <span>Template de e-mail</span>
            </div>

            <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-100">
              <mat-label>Assunto</mat-label>
              <input matInput formControlName="emailSubject">
            </mat-form-field>

            <label class="mb-2">Mensagem do e-mail</label>
            <div class="editor-container">
              <ngx-editor-menu [editor]="editorEmail" [toolbar]="toolbar"></ngx-editor-menu>
              <ngx-editor [editor]="editorEmail" formControlName="emailBody" placeholder="Escreva a mensagem..."></ngx-editor>
            </div>

            <div class="editor-links">
              <a class="variaveis-link" (click)="toggleVariaveisEmail()" id="toggle-variaveis-email">
                <mat-icon class="variaveis-icon">swap_horiz</mat-icon>
                {{ showVariaveisEmail ? 'Ocultar variáveis disponíveis' : 'Exibir variáveis disponíveis' }}
              </a>
              <a class="variaveis-link" (click)="restaurarTemplateEmail()">
                <mat-icon class="variaveis-icon">restart_alt</mat-icon>
                Restaurar texto padrão
              </a>
            </div>
            @if (showVariaveisEmail) {
              <app-alert-card type="info">
                <strong>Variáveis disponíveis para uso na mensagem:</strong>
                <ul class="variaveis-list mt-2 mb-0">
                  @for (variavel of variaveisEmail; track variavel.codigo) {
                    <li>
                      <button mat-button type="button" class="variavel-button" (click)="insertVariable(variavel.codigo)">
                        <code>{{ variavel.codigo }}</code>
                      </button>
                      <span>{{ variavel.descricao }}</span>
                    </li>
                  }
                </ul>
              </app-alert-card>
            }
          </section>
            </div>
      </div>
    </form>
    }
  </div>
</div>

<app-footer-action
  [isLoadingSalvar]="isSaving"
  [isSalvarDisabled]="!configCarregada || !form.dirty || !hasSelectedFormat"
  (cancelar)="voltar()"
  (salvar)="salvar()"></app-footer-action>
